import { render, staticRenderFns } from "./OFavoriteToggle.vue?vue&type=template&id=591260d7&"
import script from "./OFavoriteToggle.vue?vue&type=script&lang=js&"
export * from "./OFavoriteToggle.vue?vue&type=script&lang=js&"
import style0 from "./OFavoriteToggle.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports